<template>
    <div class="RoleChangeConfirmationProcedureChangesContent">
        <ul v-if="gainedFeatures.length > 0">
            <li
                v-for="label of getSortedFeeatureLabels(gainedFeatures)"
                :key="label"
            >
                {{ label }}
            </li>
        </ul>

        <div v-if="isTransferWithBothGainAndLose">
            And no longer be able to:
        </div>

        <ul v-if="lostFeatures.length > 0">
            <li
                v-for="label of getSortedFeeatureLabels(lostFeatures)"
                :key="label"
            >
                {{ label }}
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
.RoleChangeConfirmationProcedureChangesContent {
    ul li {
        padding: 2px 0;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { difference } from 'lodash';

    import { RBAC_FEATURE_PERMISSIONS_MAP } from '@evidentid/dashboard-commons/modules/role-base-access-control/constants/feature-mappings/rbacFeaturePermissionsMap.constant';
    import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

    import { UI_COMBINED_FEATUERS } from '../constants';
    import { RoleChangeType } from '../type';

    export default defineComponent({
        name: 'RoleChangeConfirmationProcedureChangesContent',
        props: {
            currentRoleFeatures: {
                type: Array as PropType<RbacFeature[]>,
                required: true,
            },
            newRoleFeatures: {
                type: Array as PropType<RbacFeature[]>,
                required: true,
            },
            roleChangeType: {
                type: String as PropType<RoleChangeType>,
                required: true,
            },
        },
        computed: {
            gainedFeatures(): RbacFeature[] {
                return difference(this.newRoleFeatures, this.currentRoleFeatures);
            },
            lostFeatures(): RbacFeature[] {
                return difference(this.currentRoleFeatures, this.newRoleFeatures);
            },
            isTransferWithBothGainAndLose(): boolean {
                return this.roleChangeType === RoleChangeType.transfer &&
                    this.gainedFeatures.length > 0 &&
                    this.lostFeatures.length > 0;
            },
        },
        methods: {
            getSortedFeeatureLabels(features: RbacFeature[]): string[] {
                return this.getFeatureLabels(features).sort();
            },
            getFeatureLabels(features: RbacFeature[]): string[] {
                const result = new Set<string>();
                const processedFeatures = new Set<RbacFeature>();
                // check and get combined features labels
                UI_COMBINED_FEATUERS.forEach(({ features: featuresToCombine, label }) => {
                    if (featuresToCombine.every((feature) => features.includes(feature))) {
                        result.add(label);
                        featuresToCombine.forEach((feature) => processedFeatures.add(feature));
                    }
                });

                // Then get remaining non combined features labels
                features.forEach((feature) => {
                    if (!processedFeatures.has(feature)) {
                        const label = RBAC_FEATURE_PERMISSIONS_MAP[feature]?.label;
                        if (label) {
                            result.add(label);
                        }
                    }
                });
                return Array.from(result);
            },
        },
    });
</script>
